<template>
    <!-- 运次统计 -->
    <div>
        <!-- 头部-->
        <div class="child-head">
            <!-- 标题 -->
            <div class="child-head-left float-l">
                <img src="../../assets/area_title.png" class="head-img">
                <span>运次统计</span>
            </div>

        </div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="content-div">
                    <!-- 地图 -->
                    <div class="content-div-1">
                        <!-- 次数 -->
                        <div class="number">
                            <div class="number-div-1" style=" margin-right: 25px;">
                                <div>累计运次</div>
                                <div class="number-div-2">
                                    <div id="qt1">{{ todayQtyStr1 }}</div>
                                    <div id="qt2">{{ todayQtyStr2 }}</div>
                                    <span id="qt3" class="number-span">,</span>
                                    <div id="qt3">{{ todayQtyStr3 }}</div>
                                    <div id="qt4">{{ todayQtyStr4 }}</div>
                                    <div id="qt5">{{ todayQtyStr5 }}</div>
                                    <span id="qt6" class="number-span">,</span>
                                    <div id="qt6">{{ todayQtyStr6 }}</div>
                                    <div id="qt7">{{ todayQtyStr7 }}</div>
                                    <div id="qt8">{{ todayQtyStr8 }}</div>
                                    <div id="qt9">{{ todayQtyStr9 }}</div>
                                    <!-- <numberFlipTwo :val="todayQtyStr8" :val2="a"/> -->

                                </div>
                            </div>
                            <div class="number-div-1">
                                <div>今日运次</div>
                                <div class="number-div-2 today">
<!--                                    <div id="qj1">{{ todayQty1 }}</div>-->
<!--                                    <div id="qj2">{{ todayQty2 }}</div>-->
<!--                                    <span class="number-span" id="qj3">,</span>-->
<!--                                    <div id="qj3">{{ todayQty3 }}</div>-->
<!--                                    <div id="qj4">{{ todayQty4 }}</div>-->
<!--                                    <div id="qj5">{{ todayQty5 }}</div>-->
                                </div>
                            </div>
                        </div>
                        <!-- 地图 -->
                        <div>
                            <nationalMap />
                        </div>
                    </div>
                    <div class="content-div-2">
                        <todayTransportEchart @change="getTodayQty" />
                    </div>
                </div>
            </contentCorner>
        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import { transportTotal } from '../../api/holdMy.js';
import nationalMap from '../../components/nationalMap';
import todayTransportEchart from '../../components/todayTransportEchart';
// import numberFlipTwo from '../../common/number-flip-two';
export default {

    data() {
        return {
            refreshtransportTotalg: null,
            todayQtyStr1: 0,
            todayQtyStr2: 0,
            todayQtyStr3: 0,
            todayQtyStr4: 0,
            todayQtyStr5: 0,
            todayQtyStr6: 0,
            todayQtyStr7: 0,
            todayQtyStr8: '0',
            todayQtyStr9: 0,
            todayQty1: 0,
            todayQty2: 0,
            todayQty3: 0,
            todayQty4: 0,
            todayQty5: 0,
            a: 0,
        }
    },
    components: { contentCorner, nationalMap, todayTransportEchart },
    created() {
        this.refreshtransportTotal();
    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.refreshtransportTotalg);
    },
    methods: {
        // 运输
        async getTransportTotal() {
            let data = {
                type: "2",// 传入用户id
            }
            transportTotal(data).then(res => {
                if (res.result == 0) {
                    this.totalQty = res.userdata + 10000000;
                    var todayQtyStr = this.totalQty + '';
                    this.todayQtyStr1 = 0;
                    this.todayQtyStr2 = 0;
                    this.todayQtyStr3 = 0;
                    this.todayQtyStr4 = 0;
                    this.todayQtyStr5 = 0;
                    this.todayQtyStr6 = 0;
                    this.todayQtyStr7 = 0;
                    this.todayQtyStr8 = 0;
                    this.todayQtyStr1 = todayQtyStr.substring(0, 1);
                    if (todayQtyStr.length > 1) {
                        this.todayQtyStr2 = todayQtyStr.substring(1, 2)
                    } else { document.getElementById('qt2').style.display = "none"; }
                    if (todayQtyStr.length > 2) {
                        this.todayQtyStr3 = todayQtyStr.substring(2, 3);
                    } else { document.getElementById('qt3').style.display = "none"; }
                    if (todayQtyStr.length > 3) {
                        this.todayQtyStr4 = todayQtyStr.substring(3, 4);
                    } else { document.getElementById('qt4').style.display = "none"; }
                    if (todayQtyStr.length > 4) {
                        this.todayQtyStr5 = todayQtyStr.substring(4, 5);
                    } else { document.getElementById('qt5').style.display = "none"; }
                    if (todayQtyStr.length > 5) {
                        this.todayQtyStr6 = todayQtyStr.substring(5, 6);
                    } else { document.getElementById('qt6').style.display = "none"; }
                    if (todayQtyStr.length > 6) {
                        this.todayQtyStr7 = todayQtyStr.substring(6, 7);
                    } else { document.getElementById('qt7').style.display = "none"; }
                    if (todayQtyStr.length > 7) {
                        this.todayQtyStr8 = todayQtyStr.substring(7, 8);

                    } else { document.getElementById('qt8').style.display = "none"; }
                    if (todayQtyStr.length > 8) {
                        this.todayQtyStr9 = todayQtyStr.substring(8, 9);
                    } else { document.getElementById('qt9').style.display = "none"; }
                }
            }).catch(error => {
                console.log(error);
            })
        },
        getTodayQty(value) {
          // 获取目标容器
          var container = document.querySelector('.number-div-2.today');
          // 清空容器内容
          container.innerHTML = '';
          // 将数字转换为字符串
          var numberStr = value.toString();
          // 计算数字长度
          var length = numberStr.length;
          // 创建DOM元素并插入到容器中
          for (var i = 0; i < length; i++) {
            // 创建数字DOM元素
            var digitDiv = document.createElement('div');
            digitDiv.textContent = numberStr[i];
            // 设置ID
            digitDiv.id = 'qj' + (i + 1);
            // 设置样式
            digitDiv.style.width = '34px';
            digitDiv.style.height = '45px';
            digitDiv.style.boxSizing = 'border-box';
            digitDiv.style.border = '1px solid rgb(89, 222, 255)';
            digitDiv.style.borderRadius = '5px';
            digitDiv.style.margin = '2px';
            digitDiv.style.textAlign = 'center';
            digitDiv.style.lineHeight = '40px';
            digitDiv.style.padding = '2px';
            container.appendChild(digitDiv);

            // 判断是否需要插入逗号
            if (i === length - 4) { // 插入逗号的位置为个十百千万十万
              var commaSpan = document.createElement('div');
              commaSpan.classList.add('number-span');
              commaSpan.textContent = ',';
              commaSpan.style.height = '45px';
              commaSpan.style.padding = '2px';
              commaSpan.style.margin = '2px';
              commaSpan.style.lineHeight = '35px';
              container.appendChild(commaSpan);
            }
          }

          this.$forceUpdate();
        },

        refreshtransportTotal() {
            this.getTransportTotal();
            if (this.refreshtransportTotalg) {
                clearInterval(this.refreshtransportTotalg);
            }
            this.refreshtransportTotalg = setInterval(() => {
                this.getTransportTotal();
            }, 10 * 1000)
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 930px;

    .content-div {
        padding: 10px 20px;

        .content-div-1 {
            width: 100%;
            height: 700px;

            .number {
                width: 800px;
                height: 78px;
                display: flex;
                font-family: 'Arial Normal', 'Arial', sans-serif;
                font-weight: 400;
                font-style: normal;
                color: rgba(255, 255, 255, 0.6549019607843137);
                text-align: left;
                margin-top: 20px;
                position: absolute;

                .number-div-1 {
                    // width: 46%;
                    height: 100%;
                }

                .today {
                    color: #FFF45C !important;
                }

                .number-div-2 {
                    height: 60px;
                    font-family: 'DIN ', 'DIN', sans-serif;
                    font-weight: 700;
                    font-style: normal;
                    font-size: 40px;
                    color: #FFFFFF;
                    display: flex;
                    margin-top: 10px;

                    .number-span {
                        height: 45px;
                        padding: 2px;
                        margin: 2px;
                        line-height: 35px;
                    }

                    div {
                        padding: 2px;
                        box-sizing: border-box;
                        width: 34px;
                        height: 45px;
                        box-sizing: border-box;
                        border: 1px solid rgba(89, 222, 255, 1);
                        border-radius: 5px;
                        margin: 2px;
                        text-align: center;
                        line-height: 40px;
                    }

                }
            }
        }

        .content-div-2 {
            width: 100%;
            height: 260px;
        }
    }
}
</style>